import { ReactNode, useEffect } from 'react';
import { trackEvent } from './_lib/eventTrack';

interface IProps {
  children: ReactNode;
  eventName: string;
  eventProps?: object;
}

export default function PageViewEvent({ eventName, eventProps, children }: IProps) {
  useEffect(() => {
    trackEvent(eventName, eventProps);
  }, []);

  return <>{children}</>;
}
